import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContactUs } from '../models/ContactUs';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  public apiPath: string = environment.apiUrl;

constructor(private http:HttpClient) { }

add(contactUs: any): Observable<any> {
  return this.http.post<any>(this.apiPath + 'ContactUs/Add', contactUs);
}

// get(CourtId: Number): Observable<any> {
//   return this.http.get<any>(this.apiPath + 'Courts/' + CourtId);
// }
}
